import dynamic from 'next/dynamic'

/**
 * Use dynamic import helper to disable SSR for this component, since the
 * `browserSupportsAdvancedUpload` function can only be run in the browser.
 */
const UploadTemplate = dynamic(() => import('./UploadTemplate'), { ssr: false })

export default UploadTemplate
